import { createAction, props } from '@ngrx/store';
import { EmailInteractionLinkPayload } from './interactions.payloads';

export const emailInteractionLink = createAction(
  '[Interactions] Email link',
  props<EmailInteractionLinkPayload>()
);
